import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { HiristJobDetail } from '@/features/hirist/job-detail'

const searchSchema = z.object({
  tab: z.enum(['overview', 'applicants']).catch('overview'),
})

export const Route = createFileRoute('/_authenticated/hirist/jobs/$jobId/')({
  component: HiristJobDetail,
  validateSearch: (search) => searchSchema.parse(search),
})
